import logo from "../../resources/icons/logo.png";

const LeftSideLoginReg: React.FC = () => {
  return (
    <div
      className="w-[calc(100%*4/9)] flex flex-col items-center justify-between"
      style={{
        background: "linear-gradient(38.32deg, #1A2835 65%, #2B4A61 35%)"
      }}
    >
      <div>{""}</div>
      <div className="flex flex-col items-center">
        <img className="w-1/4 mb-3" src={logo} alt="Logo" />
        <p className="text-4xl text-white font-bold">Build Connect</p>
      </div>
      <div className="w-2/3">
        <p className="text-sm text-center text-white">
          Connecting clients and construction companies to develop better
          together.
        </p>
      </div>
    </div>
  );
};

export default LeftSideLoginReg;
